import type { GetInsetAreaProcedure } from "./getInsetAreas"
import type { Edge2dComputed, Face2dComputed } from "../../mesh"

export const insetAreaCache: Record<
  string,
  Record<string, { result: Face2dComputed[]; procedure: GetInsetAreaProcedure }>
> = {}

export const retrieveFromCache = (
  areaId: string,
  edges: (Edge2dComputed & { setback: number })[],
):
  | { hit: { result: Face2dComputed[]; procedure: GetInsetAreaProcedure } }
  | { miss: string } => {
  const key = edges
    .map(({ p1, p2, setback }) => `${p1.x},${p1.y},${p2.x},${p2.y},${setback}`)
    .join(`|`)
  if (areaId in insetAreaCache && key in insetAreaCache[areaId]) {
    return { hit: insetAreaCache[areaId][key] }
  }

  return { miss: key }
}

export const storeInCache = (
  areaId: string,
  key: string,
  returnVal: { result: Face2dComputed[]; procedure: GetInsetAreaProcedure },
): void => {
  /* eslint-disable-next-line no-restricted-syntax */
  for (const key in insetAreaCache[areaId]) {
    if (Object.hasOwnProperty.call(insetAreaCache, key)) {
      delete insetAreaCache[areaId][key]
    }
  }
  insetAreaCache[areaId] = { [key]: returnVal }
}
